// toast.js
import ZINDEXES from '../../constants/zIndexes';
import './toast.css';

const TOAST_CONTAINER_ID = 'global-toast-container';

function getToastContainer() {
    let container = document.getElementById(TOAST_CONTAINER_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = TOAST_CONTAINER_ID;
        container.className = 'toast-container';
        container.style.zIndex = ZINDEXES.TOAST;
        document.body.appendChild(container);
    }
    return container;
}

/**
 * Show a toast message
 * @param {string} message - Text to display
 * @param {string} type - success | error | info | warning
 * @param {number} duration - How long in ms
 */
export function showToast(message, type = 'info', duration = 3000) {
    const container = getToastContainer();

    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.textContent = message;

    container.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => {
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(0)';
    });

    // Animate out and remove
    setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(50px)';
        toast.addEventListener('transitionend', () => toast.remove());
    }, duration);
}
